module.exports = __webpack_public_path__ + "static/media/ic_playlist_add_check_48px.b99a0220.svg";